import { ERegionType } from '@/editor/data/type';
import { ELayoutType } from '@/service/layout/types';

export const DEFAULT_FACE_Material_BY_TYPE: Record<
  ELayoutType,
  Partial<Record<ERegionType, { wall: string; floor: string }>>
> = {
  [ELayoutType.ABW]: {
    [ERegionType.ReceptionRoom]: {
      floor: 'FF-2',
      wall: 'WF-2'
    },
    [ERegionType.SingleRoom]: {
      floor: 'FF-2',
      wall: 'WF-2'
    },
    [ERegionType.Workspace]: {
      floor: 'FF-2',
      wall: 'WF-2'
    },
    [ERegionType.DiscussionForum]: {
      floor: 'FF-3',
      wall: 'WF-2'
    },
    [ERegionType.RestArea]: {
      floor: 'FF-1',
      wall: 'WF-2'
    }
  },
  [ELayoutType.Standard]: {
    [ERegionType.ReceptionRoom]: {
      floor: 'FF-2',
      wall: 'WF-1'
    },
    [ERegionType.SingleRoom]: {
      floor: 'FF-2',
      wall: 'WF-1'
    },
    [ERegionType.Workspace]: {
      floor: 'FF-2',
      wall: 'WF-1'
    }
  }
} as const;
